import ApnsDevicesList from './device.list';
import PhoneIphone from '@material-ui/icons/PhoneIphone';

export default {
  name: 'devices/apns',
  options: { label: 'Apns Devices' },
  list: ApnsDevicesList,
  icon: PhoneIphone
};
